<template>
  <div :class="classes">
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" :refresh="true" ref="table">
      <wt-table :list="tableData" :labels="tableLabels" >
        <template>
          <el-table-column label="操作" fixed="right" min-width="20">
            <template slot-scope="scope">
              <slot :row="scope.row"></slot>
            </template>
          </el-table-column>
        </template>
      </wt-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-detection-corpus-structure-table'

export default {
  name: 'pt-detection-corpus-structure-table',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tableLabels: {
      type: Array,
      default: () => []
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 0
    },
    requestData: {
      type: Function
    },
    category: {
      type: String,
      default: ''
    }
  },
  methods: {
    getTableData (page, next) {
      this.requestData && this.requestData(page, next)
    },
    reload () {
      this.$refs.table.load()
    },
    showReTry () {
      this.$refs.table.showReTry()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
